import { useMediaQuery } from "react-responsive"

const MainImageTitleItem = (props) => {

    const { images, imagesMobile, texts, index, selectIndicator } = props
    const isMobile = useMediaQuery({ maxWidth: 1280 })
    const activeImages = isMobile ? imagesMobile : images

    return (

        <>
            <section className="w100 flex col acenter jcenter slider-viewport">
                {activeImages.map((src, i) => (
                    <img
                        key={src}
                        alt="Imagen"
                        src={src}
                        className={`slider-image ${i === index ? "slider-image-active" : ""}`}
                    />
                ))}
                <p key={index} className="slider-text">{texts[index]}</p>
            </section>

            <section className="slider-image-separator"></section>

            <section className="indicators">
                {activeImages.map((_, i) => (
                    <button type="button" id={i} key={i} aria-label={`Mostrar imagen ${i + 1}`} aria-current={i === index} className={`dot ${i === index ? "active" : ""}`} onClick={selectIndicator}></button>
                ))}
            </section>
        </>

    )

}

export default MainImageTitleItem
